export default __webpack_public_path__ + "static/media/nfthive-icon.b6f58c3c.svg";